import { LOGO_URL } from "../assets";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-white border-t border-[#EAEAEA]"
    >
      <div className="nr-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center">
              <img
                src={LOGO_URL}
                alt="The Next Room"
                className="h-20 w-auto object-contain"
              />
            </a>
            <p className="mt-5 text-[14px] nr-text-soft max-w-sm leading-relaxed">
              Operador profesional de alquiler residencial. Nos convertimos en
              tu inquilino para que cobres puntualmente cada mes, sin gestión y
              sin riesgo de impago.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="nr-step-num">Navegar</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li><a href="#servicios" className="hover:text-[#2E8E92]">Servicios</a></li>
              <li><a href="#beneficios" className="hover:text-[#2E8E92]">Beneficios</a></li>
              <li><a href="#proceso" className="hover:text-[#2E8E92]">Proceso</a></li>
              <li><a href="#nosotros" className="hover:text-[#2E8E92]">Nosotros</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="nr-step-num">Empresa</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li><a href="#contacto" className="hover:text-[#2E8E92]">Contacto</a></li>
              <li><a href="#" className="hover:text-[#2E8E92]">Aviso legal</a></li>
              <li><a href="#" className="hover:text-[#2E8E92]">Privacidad</a></li>
              <li><a href="#" className="hover:text-[#2E8E92]">Cookies</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="nr-step-num">Contacto</div>
            <ul className="mt-5 space-y-3 text-[14px] nr-text-soft">
              <li>
                <a
                  href="mailto:hola@thenextroom.es"
                  className="hover:text-[#2E8E92]"
                  data-testid="footer-email"
                >
                  hola@thenextroom.es
                </a>
              </li>
              <li>España</li>
            </ul>
            <a
              href="https://wa.me/34681001182"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-[13px] font-sub bg-[#25D366] text-white hover:bg-[#1FBE58] transition-colors"
            >
              <MessageCircle size={15} strokeWidth={2} />
              Escríbenos por WhatsApp
            </a>
          </div>
        </div>

        <div className="nr-divider mt-12" />
        <div className="mt-6 flex flex-col md:flex-row justify-between gap-4 text-[12px] nr-text-soft">
          <div>© {year} THE NEXT ROOM. Todos los derechos reservados.</div>
          <div>Operador especializado en gestión residencial.</div>
        </div>
      </div>
    </footer>
  );
}
